export enum PatchType {
  CRATE,
  UPDATE,
  REMOVE,
}
